export const API_URL = process.env?.REACT_APP_API_URL ?? 'http://localhost:3001';
export const API_UPLOAD_PUBLIC = `${API_URL}/uploads/public`;
export const ACCESS_TOKEN = 'accessToken';
